export { Award as default } from './Award';
